import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const EmptyDataState = ({ period }) => {
    const { t } = useTranslation();

    // Dynamic message based on selected period
    const getEmptyMessage = () => {
        switch (period) {
            case 'week':
                return t('moodChart.emptyStates.week');
            case 'month':
                return t('moodChart.emptyStates.month');
            default:
                return t('moodChart.emptyStates.all');
        }
    };

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="h-52 sm:h-72 w-full flex flex-col items-center justify-center text-center p-4"
        >
            {/* Animated icon */}
            <motion.div
                animate={{
                    y: [0, -10, 0],
                    scale: [1, 1.05, 1]
                }}
                transition={{
                    duration: 2,
                    repeat: Infinity,
                    repeatType: "reverse"
                }}
                className="text-4xl sm:text-5xl mb-4"
            >
                📝
            </motion.div>

            {/* Main message */}
            <h4 className="text-base sm:text-lg font-medium text-gray-700 dark:text-gray-300 mb-1">
                {t('moodChart.noDataTitle')}
            </h4>

            {/* Period-specific message */}
            <p className="text-sm text-gray-500 dark:text-gray-400 mb-4 max-w-xs">
                {getEmptyMessage()}
            </p>

            {/* Call to action */}
            <motion.div
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="mt-2"
            >
                <Link
                    to="/app/journal"
                    className="inline-flex items-center px-3 py-2 text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 transition-colors shadow-sm"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>
                    {t('moodChart.createEntry')}
                </Link>
            </motion.div>
        </motion.div>
    );
};

export default EmptyDataState;